import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
type FaqAccordionProps = {
  items: {
    question: string;
    answer: string;
  }[];
};
export function FaqAccordion({
  items
}: FaqAccordionProps) {
  const [open, setOpen] = useState<number | null>(0);
  return <ul className="divide-y divide-navy-100 border-y border-navy-100" data-id="element-87" data-mp="1l6lwl12z8i7w">
      {items.map((item, i) => {
      const isOpen = open === i;
      return <li key={item.question} data-id="element-88" data-mp="1c6z63abscwtm" data-mpi={i}>
            <h3 data-id="element-89" data-mp="1c80fzbh2fd9r">
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-start justify-between gap-6 py-6 text-left transition-colors duration-200 hover:text-gold-dark" data-id="element-90" data-mp="1c8jzgwmd69pw">
                <span className="font-display text-lg font-medium leading-snug text-navy sm:text-xl" data-id="element-91" data-mp="2wmkdts8b6ak7">
                  {item.question}
                </span>
                <span className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-all duration-300 ${isOpen ? 'rotate-45 border-gold bg-gold text-navy' : 'border-navy-100 text-navy'}`} aria-hidden="true" data-id="element-92" data-mp="1gc470k8qshmb">
                  <PlusIcon className="h-4 w-4" data-id="element-93" data-mp="xfmkqicnx9xg" />
                </span>
              </button>
            </h3>
            <AnimatePresence initial={false} data-id="element-94" data-mp="shuh4r2nnzdf">
              {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: [0.22, 1, 0.36, 1]
          }} className="overflow-hidden" data-id="element-95" data-mp="16gkg6c91c94f">
                  <p className="max-w-3xl pb-7 pr-10 text-sm leading-relaxed text-charcoal-light sm:text-base" data-id="element-96" data-mp="1aiynajdgteea">
                    {item.answer}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </li>;
    })}
    </ul>;
}